import React, { useEffect, useState } from "react";
import "../styles/cookiepopup.css";

const CONSENT_KEY = "reyou_cookie_consent_v1";
const CONSENT_VERSION = 1;
const CONSENT_EVENT = "reyou:consent-changed";

const readStoredConsent = () => {
  try {
    const rawConsent = localStorage.getItem(CONSENT_KEY);
    if (!rawConsent) return null;

    const parsedConsent = JSON.parse(rawConsent);
    if (!parsedConsent || parsedConsent.version !== CONSENT_VERSION) return null;

    return {
      necessary: true,
      analytics: Boolean(parsedConsent.analytics),
    };
  } catch {
    return null;
  }
};

const persistConsent = ({ analytics, method }) => {
  const consent = {
    version: CONSENT_VERSION,
    necessary: true,
    analytics: Boolean(analytics),
    method,
    updatedAt: new Date().toISOString(),
  };

  localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: consent }));
  return consent;
};

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [consentExists, setConsentExists] = useState(false);

  useEffect(() => {
    const existingConsent = readStoredConsent();
    if (!existingConsent) {
      setShowBanner(true);
      return;
    }

    setConsentExists(true);
    setAnalytics(existingConsent.analytics);
  }, []);

  const saveConsent = (nextAnalytics, method) => {
    persistConsent({
      analytics: nextAnalytics,
      method,
    });

    setConsentExists(true);
    setAnalytics(Boolean(nextAnalytics));
    setShowBanner(false);
    setShowSettings(false);
  };

  const openPreferences = () => {
    const existingConsent = readStoredConsent();
    if (existingConsent) {
      setAnalytics(existingConsent.analytics);
    }

    setShowBanner(true);
    setShowSettings(true);
  };

  return (
    <>
      {showBanner ? (
        <aside
          className="cookie-consent"
          role="dialog"
          aria-modal="false"
          aria-label="Cookie-Einstellungen"
        >
          <p className="cookie-consent__text">
            Wir verwenden nur notwendige Cookies ohne Einwilligung. Analyse-Technologien setzen wir nur
            mit deiner Zustimmung ein. Details findest du in unserer <a href="/privacy">Datenschutzerklärung</a>.
          </p>

          <div className="cookie-consent__actions">
            <button
              type="button"
              className="cookie-consent__button"
              onClick={() => saveConsent(false, "reject_all")}
            >
              Nur notwendige
            </button>
            <button
              type="button"
              className="cookie-consent__button"
              onClick={() => setShowSettings((currentState) => !currentState)}
              aria-expanded={showSettings}
            >
              Einstellungen
            </button>
            <button
              type="button"
              className="cookie-consent__button"
              onClick={() => saveConsent(true, "accept_all")}
            >
              Alle akzeptieren
            </button>
          </div>

          {showSettings ? (
            <div className="cookie-consent__settings" role="group" aria-label="Cookie-Kategorien">
              <label className="cookie-consent__option">
                <input type="checkbox" checked disabled />
                <span>Notwendig (immer aktiv)</span>
              </label>
              <label className="cookie-consent__option">
                <input
                  type="checkbox"
                  checked={analytics}
                  onChange={(event) => setAnalytics(event.target.checked)}
                />
                <span>Analyse (Vercel Analytics)</span>
              </label>

              <button
                type="button"
                className="cookie-consent__button cookie-consent__button--save"
                onClick={() => saveConsent(analytics, "save_preferences")}
              >
                Auswahl speichern
              </button>
            </div>
          ) : null}
        </aside>
      ) : null}

      {consentExists ? (
        <button type="button" className="cookie-consent__manage" onClick={openPreferences}>
          Cookie-Einstellungen
        </button>
      ) : null}
    </>
  );
};

export default CookieConsent;
